// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { validateToken } from "./validateToken.js";
// import { getCookie } from "./webStorage.js";
// import { useUser } from "./userProvider.js";
// import { InfiLoader } from "../components/loader.js";

// const ProtectedRoute = ({ element: Element }) => {
//   const { setUser } = useUser();
//   const [isValidated, setIsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = getCookie("sctoken");
//     if (!token) {
//       window.location.href = "/";
//     }

//     validateToken(token)
//       .then((user) => {
//         // console.log("user PrivateRoute", user);
//         if (user?.success === true) {
//           setIsValidated(true);
//           setUser(user?.user);
//         } else {
//           setIsValidated(false);
//         }
//       })
//       .catch((error) => {
//         console.error("Token validation failed:", error);
//         setIsValidated(false);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return <InfiLoader maintext="Verifying.." />;
//   }
//   return isValidated ? <>{Element}</> : <Navigate to="/" />;
// };

// export default ProtectedRoute;










import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { validateToken } from "./validateToken.js";
import { getCookie } from "./webStorage.js";
import { useUser } from "./userProvider.js";
import { InfiLoader } from "../components/loader.js";

const ProtectedRoute = ({ element: Element }) => {
  const { setUser } = useUser();
  const [isValidated, setIsValidated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getCookie("sctoken");

    if (!token) {
      setLoading(false);
      setIsValidated(false);
      return;
    }

    const checkToken = async () => {
      try {
        const user = await validateToken(token);

        if (user?.success === true) {
          setIsValidated(true);
          setUser(user?.user);
        } else {
          setIsValidated(false);
        }
      } catch (error) {
        console.error("Token validation failed:", error);
        setIsValidated(false);
      } finally {
        setLoading(false);
      }
    };

    checkToken();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <InfiLoader maintext="Verifying.." />;
  }

  return isValidated ? <>{Element}</> : <Navigate to="/" replace />;
};

export default ProtectedRoute;